import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/lockhart")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Lockhart, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Lockhart & Caldwell County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Lockhart, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Lockhart and Caldwell County.",
      keywords: "awnings Lockhart, awning company Lockhart, custom awnings Lockhart, sail shades Lockhart, patio covers Lockhart, pergola covers Lockhart, metal awnings Lockhart, canvas awnings Lockhart, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Lockhart", "Caldwell County"),
  }),
  component: () => <CityHomePage city="Lockhart" region="Caldwell County" />,
});
